export const CURRENCIES = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  MAD: "MAD ",
  AED: "AED ",
  CAD: "C$",
};

export function formatMoney(amount, currency = "USD") {
  const symbol = CURRENCIES[currency] || "$";
  const n = Number(amount || 0);
  return `${symbol}${n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString(undefined, { weekday: "short", month: "long", day: "numeric", year: "numeric" });
}

export function formatShortDate(iso) {
  if (!iso) return "TBD";
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function getCountdown(startDate) {
  if (!startDate) return null;
  const target = new Date(startDate);
  if (isNaN(target)) return null;
  const now = new Date();
  const diff = target.getTime() - now.getTime();
  const past = diff <= 0;
  const abs = Math.abs(diff);
  const days = Math.floor(abs / 86400000);
  const hours = Math.floor((abs % 86400000) / 3600000);
  const minutes = Math.floor((abs % 3600000) / 60000);
  const seconds = Math.floor((abs % 60000) / 1000);
  return { days, hours, minutes, seconds, past };
}
